import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-3" }

import { computed, ref, watch } from "vue";
import { t } from "@/i18n";
import { ModalDefaultInner } from "@easy/ui/modals";
import { CardIcon } from "@easy/ui/cards";
import { LayoutModal } from "@easy/ui/layouts";
import { InPageUsedTools } from "@/apps/page/page-project.interface";
import { useSections } from "@/apps/page/services/useSections";
import {
    TAB_NEW_PROJECT,
    useBindSectionWithProject,
} from "@/apps/page/project/sections/useBindWithProject";
import { PageSection } from "@/apps/page/page.interfaces";
import BindSectionWithToolProjectForm from "@/apps/page/project/sections/BindSectionWithToolProjectForm.vue";
import { useActions, useState } from "@/store/vuex-composition-mappers";


export default /*@__PURE__*/_defineComponent({
  __name: 'BindSectionWithToolProjectModal',
  props: {
    sectionId: {},
    tool: {}
  },
  emits: ["close"],
  setup(__props: any) {


const props = __props;

// @ts-expect-error
const { page } = useState("page", ["page"]);
// @ts-expect-error
const { connectToolSectionWithProject, bindToolSectionWithProject } = useActions("page", [
    "connectToolSectionWithProject",
    "bindToolSectionWithProject",
]);
const { sectionTypes } = useSections();

const iconComponent = computed(() => ({
    icon: sectionTypes.value.find((s) => s.tool === props.tool)?.icon,
    cssClass: `text-${props.tool}-500`,
}));

const showModal = ref(false);
const {
    selectedTab,
    chosenProjectId,
    shouldHaveExistingOption,
    toolProjects,
    project,
    projectNameError,
    bindWithProject,
    resetForm,
    onFieldBlur,
} = useBindSectionWithProject(props, {
    page,
    connectToolSectionWithProject,
    bindToolSectionWithProject,
});

const bindToolModalData = computed(() => ({
    title: t("page.bind_section_modal.title"),
    description: t(
        shouldHaveExistingOption.value
            ? "page.bind_section_modal.description"
            : "page.bind_section_modal.description_creation"
    ),
    ctaLabel: t(
        selectedTab.value === TAB_NEW_PROJECT
            ? "page.bind_section_modal.create_project"
            : "page.bind_section_modal.fill_with_project",
        { tool: props.tool }
    ),
}));

watch(
    props,
    (props) => {
        showModal.value = Boolean(props.tool);
    },
    { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (showModal.value)
    ? (_openBlock(), _createBlock(_unref(LayoutModal), {
        key: 0,
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showModal).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ModalDefaultInner), {
            modelValue: showModal.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showModal).value = $event)),
            "modal-data": bindToolModalData.value,
            onCta: _unref(bindWithProject),
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
          }, _createSlots({
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(BindSectionWithToolProjectForm, {
                  sectionId: _ctx.sectionId,
                  tool: _ctx.tool,
                  toolProjects: _unref(toolProjects),
                  pageNameBlur: _unref(onFieldBlur),
                  projectNameError: _unref(projectNameError),
                  onTabSwitched: _unref(resetForm),
                  onActionSubmit: _unref(bindWithProject),
                  selectedTab: _unref(selectedTab),
                  "onUpdate:selectedTab": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedTab) ? (selectedTab).value = $event : null)),
                  shouldHaveExistingOption: _unref(shouldHaveExistingOption),
                  "onUpdate:shouldHaveExistingOption": _cache[1] || (_cache[1] = ($event: any) => (_isRef(shouldHaveExistingOption) ? (shouldHaveExistingOption).value = $event : null)),
                  chosenProjectId: _unref(chosenProjectId),
                  "onUpdate:chosenProjectId": _cache[2] || (_cache[2] = ($event: any) => (_isRef(chosenProjectId) ? (chosenProjectId).value = $event : null)),
                  projectName: _unref(project).projectName,
                  "onUpdate:projectName": _cache[3] || (_cache[3] = ($event: any) => ((_unref(project).projectName) = $event))
                }, null, 8, ["sectionId", "tool", "toolProjects", "pageNameBlur", "projectNameError", "onTabSwitched", "onActionSubmit", "selectedTab", "shouldHaveExistingOption", "chosenProjectId", "projectName"])
              ])
            ]),
            _: 2
          }, [
            (iconComponent.value.icon)
              ? {
                  name: "icon",
                  fn: _withCtx(() => [
                    _createVNode(_unref(CardIcon), null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(iconComponent.value.icon), {
                          class: _normalizeClass(["h-4 w-4", iconComponent.value.cssClass])
                        }, null, 8, ["class"]))
                      ]),
                      _: 1
                    })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "modal-data", "onCta"])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})